import React, { useState } from 'react';
import { Route } from 'react-router-dom';
import { Layout } from 'antd';
import styled from 'styled-components';

import DDSCHeader from 'src/components/Header/DDSCHeader';

const { Content } = Layout;

const DDSCContent = styled(Content)`
  margin: 0;
  height: calc(100vh - 77px);
  overflow: hidden;
  background: transparent;

  @media (max-width: 1100px), (max-height: 720px) {
    height: calc(100vh - 62px);
  }

  @media (max-width: 900px), (max-height: 620px) {
    height: calc(100vh - 54px);
  }
`;

function DDSCLayout({ component: Component, ...rest }) {
  const [title, setTitle] = useState(0);
  const [hideHeader, setHideHeader] = useState(false);

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout
          style={{
            height: '100vh',
            overflow: 'hidden',
            backgroundImage:
              "linear-gradient(180deg, rgba(8,20,74,.28), rgba(7,22,82,.18)), url('/images/ddsc/bg.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <Layout style={{ background: 'transparent' }}>
            {!hideHeader ? <DDSCHeader title={title} /> : null}
            <DDSCContent>
              <Component onChangeTitle={(v) => setTitle(v)} onSetHideHeader={(v) => setHideHeader(v)} {...matchProps} {...rest} />
            </DDSCContent>
          </Layout>
        </Layout>
      )}
    />
  );
}

export default DDSCLayout;
